export const testimonials = [
  {
    name: 'Марія Петренко',
    location: 'Київ',
    text: 'Чудові свічки! Аромат лаванди справді заспокоює. Замовляю постійно!',
    rating: 5,
    avatar: '👩‍💼',
  },
  {
    name: 'Олександр Іваненко',
    location: 'Львів',
    text: 'Подарував дружині набір - тепер це наша традиція романтичних вечорів.',
    rating: 5,
    avatar: '👨‍🎨',
  },
  {
    name: 'Анна Коваленко',
    location: 'Одеса',
    text: 'Використовую у своєму спа-салоні. Клієнти в захваті від ароматів!',
    rating: 5,
    avatar: '👩‍⚕️',
  },
];

export default testimonials;
